import React from 'react';

import { Icon, layout } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdSettings,
  MdChat,
  MdCampaign,
  MdOutlineDescription,
  MdPhoneInTalk,
  MdCallReceived,
  MdCallMade,
} from 'react-icons/md';
import { GrFormEdit } from 'react-icons/gr';
import { FaUsers } from 'react-icons/fa';
import {
  FaUserCheck,
  FaUserClock,
  FaAddressBook,
  FaPhoneAlt,
} from 'react-icons/fa';
import { FaUserDoctor } from 'react-icons/fa6';
import { GiMedicines } from 'react-icons/gi';
import { FaCodeBranch } from 'react-icons/fa6';
import { MdHomeRepairService } from 'react-icons/md';
import { MdMedicalServices } from 'react-icons/md';
import { BiSolidPackage } from 'react-icons/bi';
import { MdPerson3 } from 'react-icons/md';
import { FaHandHoldingMedical } from 'react-icons/fa6';
import { MdManageAccounts } from 'react-icons/md';
import { CgDatabase } from 'react-icons/cg';
import { IoMdDoneAll } from 'react-icons/io';
import { AiOutlineMedicineBox } from 'react-icons/ai';
import { GrUserAdmin } from 'react-icons/gr';
import { GrTableAdd } from 'react-icons/gr';
import { FaLaptopMedical } from 'react-icons/fa';
import { BsFileMedical, BsChatDotsFill } from 'react-icons/bs';
import { LiaUserPlusSolid } from 'react-icons/lia';
import { RiChatFollowUpLine } from 'react-icons/ri';
import { LuUser } from 'react-icons/lu';
import {
  LiaSortAmountUpSolid,
  LiaSortAmountDownAltSolid,
} from 'react-icons/lia';
import { LuFileCheck, LuFileX } from 'react-icons/lu';
import { VscNotebook } from 'react-icons/vsc';
import { LiaFileInvoiceSolid } from 'react-icons/lia';
import { LuFileText } from 'react-icons/lu';
import { AiOutlineIssuesClose } from 'react-icons/ai';
import { BiCommentCheck } from 'react-icons/bi';
import { RiLockPasswordLine } from 'react-icons/ri';
import { RiCoupon3Line } from 'react-icons/ri';

// Admin Imports
import Profile from 'views/admin/profile';
import Lead from 'views/admin/lead';
import SignIn from 'views/auth/signIn';
import MasterDashboard from 'views/master/default';
import Doctor from 'views/master/doctor';
import Branch from 'views/master/branch';
import ChangePasswordRequest from 'views/master/ChnagePass/index';
import Councelor from 'views/master/counselor';
import DoctorDashboard from 'views/doctor/default';
import AdminUser from 'views/master/adminUser/Index';
import WorkReport from 'views/master/report/Index';
import FileView from 'views/admin/viewLead/FileView';
import FollowUp from 'views/master/followup/FollowUp';
import { compose } from 'redux';
import AllFollowUp from 'views/master/followup/AllFollowUp';
import Setting from 'views/master/setting/Index';
import SuperAdminDashboard from './views/SuperAdmin/default';
import Admins from './views/SuperAdmin/admin';
import ActiveAdmins from './views/SuperAdmin/activeAdmin';
import ExpiredAdmins from './views/SuperAdmin/expiredAdmin';
import Plans from './views/SuperAdmin/plans';
import SuperAdminList from './views/SuperAdmin/superAdmins';
import ExtraAdminList from './views/admin/admins';
import FormFields from './views/admin/Formfilds/index';
import CreateModal from './views/admin/lead/CreateModal';
import Birthday from 'views/admin/birthday/birthday';

//chatbox
import Contacts from './views/master/chatbox/Contacts/index.jsx';
import Campaigns from './views/master/chatbox/Campaigns/index.jsx';
import Templates from './views/master/chatbox/Templates/index.jsx';
import Chat from './views/master/chatbox/Chat/index.jsx';

//IVR
import IncomingCall from './views/master/IVR/Incomming/index.jsx';
import OutgoingCall from './views/master/IVR/Outgoing/index.jsx';

const type = localStorage.getItem('type');
const isAuthenticated = localStorage.getItem('isAuthenticated');
const isWadaddy = localStorage.getItem('isWadaddy') === 'true';
const isIvr = localStorage.getItem('isIvr') === 'true';
let routes = [];

if (!isAuthenticated) {
  routes.push({
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <SignIn />,
  });
}

if (type === 'Admin') {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/masterDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },
    // {
    //   name: 'Master',
    //   layout: '/master',
    //   path: '/masters',
    //   icon: <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />,
    //   component: <ExtraAdminList />,
    // },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <LiaUserPlusSolid width="20px" height="20px" color="inherit" />,
          path: '/addLead',
          component: <CreateModal />,
        },
        {
          name: 'All Lead',
          layout: '/master',
          icon: <LuFileText width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: <BiCommentCheck width="20px" height="20px" color="inherit" />,
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
        {
          name: 'Today Birthday',
          layout: '/master',
          icon: (
            <Icon as={MdPerson} width="20px" height="20px" color="inherit" />
          ),
          path: '/birthdays',
          component: <Birthday />,
        },
      ],
    },
    ...(isIvr
      ? [
          {
            name: 'IVR',
            layout: '/master',
            icon: (
              <Icon
                as={MdPhoneInTalk}
                width="20px"
                height="20px"
                color="inherit"
              />
            ),
            path: '/ivr/incoming',
            component: <IncomingCall />,
            children: [
              {
                name: 'Incoming Call',
                layout: '/master',
                path: '/ivr/incoming',
                icon: (
                  <Icon
                    as={MdCallReceived}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: <IncomingCall />,
              },
              {
                name: 'Outgoing Call',
                layout: '/master',
                path: '/ivr/outgoing',
                icon: (
                  <Icon
                    as={MdCallMade}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: <OutgoingCall />,
              },
            ],
          },
        ]
      : []),
    {
      name: 'Master',
      layout: '/master',
      icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
      path: '/Consult',
      component: <Branch />,
      children: [
        {
          name: 'Branch',
          layout: '/master',
          path: '/branch',
          icon: <FaCodeBranch width="20px" height="20px" color="inherit" />,
          component: <Branch />,
        },
        {
          name: 'Form Fields',
          layout: '/master',
          path: '/formFields',
          icon: (
            <Icon as={GrFormEdit} width="20px" height="20px" color="inherit" />
          ),
          component: <FormFields />,
        },
        {
          name: 'Change Password',
          layout: '/master',
          path: '/changePassword',
          icon: (
            <RiLockPasswordLine width="20px" height="20px" color="inherit" />
          ),
          component: <ChangePasswordRequest />,
        },
      ],
    },
    {
      name: 'Admin User',
      layout: '/master',
      icon: (
        <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />
      ),
      path: '/adminUser',
      component: <AdminUser />,
      children: [
        {
          name: 'Admin User',
          layout: '/master',
          path: '/adminUser',
          icon: <GrUserAdmin width="20px" height="20px" color="inherit" />,
          component: <AdminUser />,
        },
        {
          name: 'Master',
          layout: '/master',
          path: '/masters',
          icon: (
            <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />
          ),
          component: <ExtraAdminList />,
        },
      ],
    },
    // {
    //   name: 'Admin User',
    //   layout: '/master',
    //   icon: <GrUserAdmin width="20px" height="20px" color="inherit" />,
    //   path: '/adminUser',
    //   component: <AdminUser />,
    // },
    {
      name: 'Setting',
      layout: '/master',
      path: '/Setting',
      icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
      component: <Setting />,
    },
  );
  if (isWadaddy) {
    routes.push({
      name: 'WA Daddy',
      layout: '/master',
      icon: <Icon as={MdChat} width="20px" height="20px" color="inherit" />,
      path: '/chatbox/contacts',
      component: <Contacts />,
      children: [
        {
          name: 'Contacts',
          layout: '/master',
          path: '/chatbox/contacts',
          icon: (
            <Icon
              as={FaAddressBook}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Contacts />,
        },
        {
          name: 'Campaigns',
          layout: '/master',
          path: '/chatbox/campaigns',
          icon: (
            <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />
          ),
          component: <Campaigns />,
        },
        {
          name: 'Templates',
          layout: '/master',
          path: '/chatbox/templates',
          icon: (
            <Icon
              as={MdOutlineDescription}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Templates />,
        },
        {
          name: 'Chat',
          layout: '/master',
          path: '/chatbox/chat',
          icon: (
            <Icon
              as={BsChatDotsFill}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Chat />,
        },
      ],
    });
  }
  // Restricted: only this specific admin sees the report link
  if (
    ['68230b904a829e8e83ba4857', '6a4495adc65a7ac36fdb426e'].includes(
      localStorage.getItem('id'),
    )
  ) {
    routes.push({
      name: 'Work Report',
      layout: '/master',
      path: '/workReport',
      icon: <Icon as={LuFileText} width="20px" height="20px" color="inherit" />,
      component: <WorkReport />,
    });
  }
}
if (type === 'Admin2') {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/masterDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },

    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <LiaUserPlusSolid width="20px" height="20px" color="inherit" />,
          path: '/addLead',
          component: <CreateModal />,
        },
        {
          name: 'All Lead',
          layout: '/master',
          icon: <LuFileText width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: <BiCommentCheck width="20px" height="20px" color="inherit" />,
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
        {
          name: 'Today Birthday',
          layout: '/master',
          icon: (
            <Icon as={MdPerson} width="20px" height="20px" color="inherit" />
          ),
          path: '/birthdays',
          component: <Birthday />,
        },
      ],
    },
    ...(isIvr
      ? [
          {
            name: 'IVR',
            layout: '/master',
            icon: (
              <Icon
                as={MdPhoneInTalk}
                width="20px"
                height="20px"
                color="inherit"
              />
            ),
            path: '/ivr/incoming',
            component: <IncomingCall />,
            children: [
              {
                name: 'Incoming Call',
                layout: '/master',
                path: '/ivr/incoming',
                icon: (
                  <Icon
                    as={MdCallReceived}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: <IncomingCall />,
              },
              {
                name: 'Outgoing Call',
                layout: '/master',
                path: '/ivr/outgoing',
                icon: (
                  <Icon
                    as={MdCallMade}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: <OutgoingCall />,
              },
            ],
          },
        ]
      : []),
    {
      name: 'Master',
      layout: '/master',
      icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
      path: '/Consult',
      component: <Branch />,
      children: [
        {
          name: 'Branch',
          layout: '/master',
          path: '/branch',
          icon: <FaCodeBranch width="20px" height="20px" color="inherit" />,
          component: <Branch />,
        },
        {
          name: 'Form Fields',
          layout: '/master',
          path: '/formFields',
          icon: (
            <Icon as={GrFormEdit} width="20px" height="20px" color="inherit" />
          ),
          component: <FormFields />,
        },
      ],
    },
    {
      name: 'Admin User',
      layout: '/master',
      icon: <GrUserAdmin width="20px" height="20px" color="inherit" />,
      path: '/adminUser',
      component: <AdminUser />,
    },
    {
      name: 'Setting',
      layout: '/master',
      path: '/Setting',
      icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
      component: <Setting />,
    },
  );
  if (isWadaddy) {
    routes.push({
      name: 'WA Daddy',
      layout: '/master',
      icon: <Icon as={MdChat} width="20px" height="20px" color="inherit" />,
      path: '/chatbox/contacts',
      component: <Contacts />,
      children: [
        {
          name: 'Contacts',
          layout: '/master',
          path: '/chatbox/contacts',
          icon: (
            <Icon
              as={FaAddressBook}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Contacts />,
        },
        {
          name: 'Campaigns',
          layout: '/master',
          path: '/chatbox/campaigns',
          icon: (
            <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />
          ),
          component: <Campaigns />,
        },
        {
          name: 'Templates',
          layout: '/master',
          path: '/chatbox/templates',
          icon: (
            <Icon
              as={MdOutlineDescription}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Templates />,
        },
        {
          name: 'Chat',
          layout: '/master',
          path: '/chatbox/chat',
          icon: (
            <Icon
              as={BsChatDotsFill}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Chat />,
        },
      ],
    });
  }
  if (
    ['68230b904a829e8e83ba4857', '6a4495adc65a7ac36fdb426e'].includes(
      localStorage.getItem('id'),
    )
  ) {
    routes.push({
      name: 'Work Report',
      layout: '/master',
      path: '/workReport',
      icon: <Icon as={LuFileText} width="20px" height="20px" color="inherit" />,
      component: <WorkReport />,
    });
  }
}

if (type === 'Manager') {
  routes.push(
    {
      name: 'Master Dashboard',
      layout: '/master',
      path: '/masterDashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <MasterDashboard />,
    },
    {
      name: 'CRM',
      layout: '/master',
      icon: <MdManageAccounts width="20px" height="20px" color="inherit" />,
      path: '/lead',
      component: <Lead />,
      children: [
        {
          name: 'Add Lead',
          layout: '/master',
          icon: <LiaUserPlusSolid width="20px" height="20px" color="inherit" />,
          path: '/addLead',
          component: <CreateModal />,
        },
        {
          name: 'All Lead',
          layout: '/master',
          icon: <LuFileText width="20px" height="20px" color="inherit" />,
          path: '/lead',
          component: <Lead />,
        },
        {
          name: 'Today Followup',
          layout: '/master',
          icon: (
            <RiChatFollowUpLine width="20px" height="20px" color="inherit" />
          ),
          path: '/followup',
          component: <FollowUp />,
        },
        {
          name: 'All Followup',
          layout: '/master',
          icon: <BiCommentCheck width="20px" height="20px" color="inherit" />,
          path: '/allfollowup',
          component: <AllFollowUp />,
        },
        {
          name: 'View Lead',
          layout: '/master',
          icon: <GrTableAdd width="20px" height="20px" color="inherit" />,
          path: '/viewLead/:id',
          component: <FileView />,
        },
        {
          name: 'Today Birthday',
          layout: '/master',
          icon: (
            <Icon as={MdPerson} width="20px" height="20px" color="inherit" />
          ),
          path: '/birthdays',
          component: <Birthday />,
        },
      ],
    },
    ...(isIvr
      ? [
          {
            name: 'IVR',
            layout: '/master',
            icon: (
              <Icon
                as={MdPhoneInTalk}
                width="20px"
                height="20px"
                color="inherit"
              />
            ),
            path: '/ivr/incoming',
            component: <IncomingCall />,
            children: [
              {
                name: 'Incoming Call',
                layout: '/master',
                path: '/ivr/incoming',
                icon: (
                  <Icon
                    as={MdCallReceived}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: <IncomingCall />,
              },
              {
                name: 'Outgoing Call',
                layout: '/master',
                path: '/ivr/outgoing',
                icon: (
                  <Icon
                    as={MdCallMade}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: <OutgoingCall />,
              },
            ],
          },
        ]
      : []),
  );
  if (isWadaddy) {
    routes.push({
      name: 'WA Daddy',
      layout: '/master',
      icon: <Icon as={MdChat} width="20px" height="20px" color="inherit" />,
      path: '/chatbox/contacts',
      component: <Contacts />,
      children: [
        {
          name: 'Contacts',
          layout: '/master',
          path: '/chatbox/contacts',
          icon: (
            <Icon
              as={FaAddressBook}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Contacts />,
        },
        {
          name: 'Campaigns',
          layout: '/master',
          path: '/chatbox/campaigns',
          icon: (
            <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />
          ),
          component: <Campaigns />,
        },
        {
          name: 'Templates',
          layout: '/master',
          path: '/chatbox/templates',
          icon: (
            <Icon
              as={MdOutlineDescription}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Templates />,
        },
        {
          name: 'Chat',
          layout: '/master',
          path: '/chatbox/chat',
          icon: (
            <Icon
              as={BsChatDotsFill}
              width="20px"
              height="20px"
              color="inherit"
            />
          ),
          component: <Chat />,
        },
      ],
    });
  }
}

if (type === 'SuperAdmin') {
  routes.push(
    {
      name: 'Super Admin Dashboard',
      layout: '/superadmin',
      path: '/dashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <SuperAdminDashboard />,
    },
    {
      name: 'Admin User',
      layout: '/superadmin',
      icon: <FaUsers width="20px" height="20px" color="inherit" />,
      path: '/adminusers',
      component: <Admins />,
      children: [
        {
          name: 'Super Admin',
          layout: '/superadmin',
          path: '/superadmins',
          icon: (
            <Icon as={GrUserAdmin} width="20px" height="20px" color="inherit" />
          ),
          component: <SuperAdminList />,
        },
        {
          name: 'All Admin Users',
          layout: '/superadmin',
          icon: <FaUsers width="20px" height="20px" color="inherit" />,
          path: '/alladminusers',
          component: <Admins />,
        },
        {
          name: 'Active Admin Users',
          layout: '/superadmin',
          icon: <FaUserCheck width="20px" height="20px" color="inherit" />,
          path: '/activeadminusers',
          component: <ActiveAdmins />,
        },
        {
          name: 'Expired Admin Users',
          layout: '/superadmin',
          icon: <FaUserClock width="20px" height="20px" color="inherit" />,
          path: '/expiredadminusers',
          component: <ExpiredAdmins />,
        },
      ],
    },
    {
      name: 'Plans',
      layout: '/superadmin',
      path: '/plans',
      icon: <RiCoupon3Line width="20px" height="20px" color="inherit" />,
      component: <Plans />,
    },
  );
}

if (type === 'SuperAdmin2') {
  routes.push(
    {
      name: 'Super Admin Dashboard',
      layout: '/superadmin',
      path: '/dashboard',
      icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
      component: <SuperAdminDashboard />,
    },
    {
      name: 'Admin User',
      layout: '/superadmin',
      icon: <FaUsers width="20px" height="20px" color="inherit" />,
      path: '/adminusers',
      component: <Admins />,
      children: [
        {
          name: 'All Admin Users',
          layout: '/superadmin',
          icon: <FaUsers width="20px" height="20px" color="inherit" />,
          path: '/alladminusers',
          component: <Admins />,
        },
        {
          name: 'Active Admin Users',
          layout: '/superadmin',
          icon: <FaUserCheck width="20px" height="20px" color="inherit" />,
          path: '/activeadminusers',
          component: <ActiveAdmins />,
        },
        {
          name: 'Expired Admin Users',
          layout: '/superadmin',
          icon: <FaUserClock width="20px" height="20px" color="inherit" />,
          path: '/expiredadminusers',
          component: <ExpiredAdmins />,
        },
      ],
    },
    {
      name: 'Plans',
      layout: '/superadmin',
      path: '/plans',
      icon: <RiCoupon3Line width="20px" height="20px" color="inherit" />,
      component: <Plans />,
    },
  );
}

export default routes;
